import paymentTypes from '../data/paymentTypes';
import parameterService from './parameterService';
import creditCardTypes from '../data/creditCardTypes';

const possibleCreditCardTypes = creditCardTypes.map(ele => ele.apiType);

class PaymentTypeService {

    constructor() {
        this.paymentTypes = null;
    }

    getPaymentTypes() {
        if (this.paymentTypes instanceof Array) {
            return this.paymentTypes;
        }

        const payTypes = parameterService.payTypes;
        const filteredPayTypes = [];

        payTypes.forEach(payType => {
            let matchingPayTypes = paymentTypes.filter(ele => ele.apiType === payType);
            if (matchingPayTypes.length === 0) {

                //check for credit card types
                if (filteredPayTypes.filter(ele => ele.apiType === 'CC').length || possibleCreditCardTypes.indexOf('CC_' + payType) === -1) {
                    return;
                }

                matchingPayTypes = paymentTypes.filter(ele => ele.apiType === 'CC');

                if (matchingPayTypes.length === 0) {
                    return;
                }
            }
            filteredPayTypes.push(matchingPayTypes[0]);
        });


        this.paymentTypes = filteredPayTypes;
        return this.paymentTypes;
    }
}

export default new PaymentTypeService();



// WEBPACK FOOTER //
// ./src/services/paymentTypeService.js